import { createCompanyLogoPath } from 'resources/document/generateStoragePath';

import { removeFile, uploadFileAndGetPublicUrl } from 'services/storage.service';
import { updateCompany } from 'resources/company/company.service';

const setCompanyBranding = async ({ company, imageFile, bgcColor }) => {
  const fieldsToUpdate = {};
  if (imageFile) {
    if (company.logo_url) {
      // TODO: move this structure into helper
      const bucketPath = 'companies/';
      const path = company.logo_url.substr(company.logo_url.indexOf(bucketPath) + bucketPath.length);

      await removeFile({
        bucket: 'companies',
        path,
      });
    }

    const publicUrl = await uploadFileAndGetPublicUrl({
      bucket: 'companies',
      file: imageFile,
      path: createCompanyLogoPath({ companyId: company.id, fileName: imageFile.name }),
    });

    fieldsToUpdate.logo_url = publicUrl;
  }

  if (bgcColor) {
    fieldsToUpdate.bgc_color = bgcColor;
  }

  await updateCompany({
    id: company.id,
    ...fieldsToUpdate,
  });
};

export default setCompanyBranding;
